
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"32","cy":"32","r":"4","fill":"#66B132"}}),_c('path',{attrs:{"d":"M33.2715 7.22949C33.2715 7.22949 36.2317 6.10424 35.9854 8.83691C35.9031 9.96233 35.1635 13.9016 34.5879 18.1621L33.3379 26.1514C32.9076 26.0533 32.46 26 32 26C29.025 26 26.5568 28.1654 26.083 31.0059C24.3598 29.9033 20.2825 27.2974 18.6348 25.8799C18.0592 25.3975 17.4022 24.433 18.7178 23.3076L27.3516 15.2686C28.3383 14.3039 29.325 12.0532 25.2139 14.7861L13.7012 22.4229C13.6848 22.4328 12.3703 23.2219 9.91895 22.5029L4.57422 20.8955C4.57422 20.8955 2.60041 19.6893 5.97168 18.4834C14.1945 14.7052 24.3087 10.8469 33.2715 7.22949Z","fill":"#79919C"}})])
          )
        }
      }
    